import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
`;

export const ShadowWrap = styled.div`
  overflow: visible;
  margin-bottom: 0;
  padding-bottom: 0;
`;

export const Content = styled.div`
  padding: 0;
  background: transparent;
`;

export const CountryButton = styled.button`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  background: #fff;
  border-radius: 12px;
  padding: 12px 14px;
  text-align: left;
  box-shadow: none;
  border: 1px solid #d8d8d8;
  cursor: pointer;
`;

export const CountryText = styled.div`
  font-size: 16px;
  font-weight: 900;
  color: #000000;
`;

export const TravelText = styled.div`
  font-size: 12px;
  color: #757575;
  line-height: 16px;
  margin-top: 4px;
`;

export const EditLink = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: #008cff;
  flex-shrink: 0;
  cursor: pointer;
`;
